<div class="layout-wrapper" (click)="onLayoutClick()"
     [ngClass]="{'layout-menu-overlay': isOverlay(),
                'layout-menu-overlay-active': overlayMenuActive,
                'layout-menu-horizontal': isHorizontal(),
                'layout-mobile-active': overlayMenuMobileActive,
                'layout-fullwidth': wrapperMode}" [class]="layout">

    <app-topbar></app-topbar>

    <app-menu></app-menu>

    <app-actionbar></app-actionbar>

    <div class="layout-content">
        <router-outlet></router-outlet>
    </div>

    <app-footer></app-footer>

    <app-config></app-config>

    <div class="layout-mask"></div>
</div>
